import { PartnershipMode } from 'core/agency/Agency';

export type Advertiser = {
  id: number;
  agencyId: number;
  advertiserName: string;
  website: string;
  category?: string;
  note?: string;
  state: AdvertiserState;
  productFeedID: string;
  isProductFeedReady: boolean;
  preferredPublisherId: number[];
  partnershipModeId: PartnershipMode;
};

export type ChannelAccount = {
  accountId: string,
  channelType: string
};

export enum AdvertiserState {
  ACTIVE = 1,
  ARCHIVED
}
